<template>
  <div class="contacts-map">
    <div v-if="withFilter" class="contacts-map__filter">
      <custom-select
        placeholder="Выберите"
        :data-array="dropdownOptions"
        v-model="customSelectValue"
        no-empty
        class="contacts-map__filter-select"
        @input="onChangeSelectValue"
      />
    </div>
    <div v-if="currentItem" class="contacts__cols">
      <div class="contacts__col contacts__col_flex">
        <div v-if="currentItem.phone || currentItem.workSchedule">
          <h3 v-html="currentItem.phone" />
          <p v-html="currentItem.workSchedule" />
        </div>
        <div v-if="currentItem.email">
          <h3><a :href="'mailto:' + currentItem.email" v-html="currentItem.email" /></h3>
          <p>Получить дополнительную информацию о&nbsp;порядке посещения</p>
        </div>
      </div>
      <div v-if="currentItem.address || currentItem.routeDescription" class="contacts__col">
        <h3 v-html="currentItem.address" />
        <p v-html="currentItem.routeDescription" />
      </div>
    </div>
    <div :class="['map', {'map_small': small}]">
      <img
        v-if="withFilter ? currentItem.mapImage : mapImage"
        class="map__image"
        :src="withFilter ? currentItem.mapImage : mapImage"
        alt="Как добраться"
      >
      <yandex-map
        v-else
        ref="map"
        :coords="currentCoords"
        :zoom="zoom"
        :scroll-zoom="true"
        :controls="['zoomControl']"
        @map-was-initialized="init"
      >
        <ymap-marker
          v-for="(marker, index) in resultMarkers"
          :key="`map-marker-${marker.id}`"
          :marker-id="marker.id"
          :marker-type="marker.type"
          :coords="marker.coords"
          :icon="small ? marker.icon : marker.markerIcon"
          @click="currentItem = items[index]"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import CustomSelect from "./CustomSelect";
import { setQuery } from '../tools/queryHelper'

export default {
  name: "ContactsMap",
  components: { yandexMap, ymapMarker, CustomSelect },
  props: {
    coords: {
      type: Array,
      default: () => [55.792399, 37.571148],
    },
    small: {
      type: Boolean,
      default: false,
    },
    mapImage: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [{
        id: 0,
        coords: [55.792399, 37.571148],
        phone: '',
        workSchedule: '',
        email: '',
        address: '',
        routeDescription: '',
      }],
    },
    isMoscow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      settings: {
        apiKey: "",
        lang: "ru_RU",
        coordorder: "latlong",
        enterprise: false,
        version: "2.1"
      },
      currentCoords: this.coords.map(Number),
      currentItem: this.items[0],
      zoom: this.small ? 17 : (this.items.length > 1 ? 12 : 15),
      customSelectValue: ''
    };
  },
  created() {
    if (this.isMoscow && this.dropdownOptions?.length) {
      const activeItem = this.items.find(item => item.isActive)

      this.customSelectValue = activeItem?.code || this.items?.[0]?.code

      if (activeItem?.code) {
        setQuery({ params: { branch: activeItem.code } })
        this.updateCurrentData(activeItem)
      }
    }
  },
  methods: {
    init(instance) {
      this.map = instance;
    },
    onChangeSelectValue(v) {
      setQuery({ params: { branch: v } })
      const currentItem = this.items.find(item => item.code === v)
      this.updateCurrentData(currentItem)
    },
    createMarkerItem(item) {
      return {
        id: item.id,
        type: "placemark",
        coords: item.coords,
        icon: {
          color: "red",
          glyph: "CircleDot"
        },
        markerIcon: {
          layout: 'default#image',
          imageHref: item.id === this.currentItem.id
            ? '/frontend/assets/img/icons/map-marker.svg'
            : '/frontend/assets/img/icons/map-marker-small.svg',
          imageSize: item.id === this.currentItem.id ? [80, 80] : [40, 40],
          imageOffset: item.id === this.currentItem.id ? [-40, -40] : [-20, -20],
        }
      }
    },
    updateCurrentData(item) {
      if (!item) {
        return
      }

      this.currentItem = item
      this.currentCoords = item.coords.map(Number)
    }
  },
  computed: {
    markers() {
      return this.items.map(item => this.createMarkerItem(item));
    },

    resultMarkers() {
      return this.withFilter ? this.filteredMarkers : this.markers
    },

    filteredMarkers() {
      return this.withFilter && this.items?.length
        ? this.items.filter(item => item.code === this.customSelectValue).map(item => this.createMarkerItem(item))
        : []
    },

    dropdownOptions() {
      return this.isMoscow && this.items?.length
        ? this.items.map(item => ({ text: item.name, value: item.code }))
        : []
    },

    withFilter() {
      return this.isMoscow && this.dropdownOptions?.length > 0
    }
  },
};
</script>

<style lang="scss">
$b: '.contacts-map';

#{$b} {

  // .contacts-map__filter
  &__filter {
    margin-bottom: 24px;

    // .contacts-map__filter-select
    &-select {
      min-width: 200px;
    }
  }
}
</style>
